import React from 'react';
import Component, { Props } from './Component';
import Connector from './Connector';
import { StyledWrapper } from './styled';

const StyledComponent = (props: Omit<Props, 'intl'>) => (
  <StyledWrapper>
    <Component {...props} />
  </StyledWrapper>
);

export default Connector(StyledComponent);
